import { render } from "./syntheseTicket.vue?vue&type=template&id=3d92a4ed"
import script from "./syntheseTicket.vue?vue&type=script&lang=ts"
export * from "./syntheseTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script